import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/iconfont/iconfont.css'
import VueClibpoard from 'vue-clipboard3'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import CryptoJS from 'crypto-js';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// <!-- version: 1.7.15; date: 2023-03-31 17:39:18 -->

const app =createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus,{locale:zhCn}).use(store).use(VueClibpoard).use(router).use(CryptoJS).mount('#app')
